import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/src/app/(webapp)/[locale]/programs/[id]/page.tsx");
